module.exports = __webpack_public_path__ + "static/img/9.9c63215.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/9.png
// module id = EUQD
// module chunks = 0